import { observer } from "mobx-react-lite";
import React from "react";
import { useStore } from "../../helpers";
import { useNavigate, useParams } from "react-router-dom";
import { safe_get } from "../../report-visuals";
import { RenderRequestStatus } from "../beneficiary-management";
import { DataNotAvailable } from "../../flexistore/renderkeys/mh-2024-field";
import { Fade } from "react-awesome-reveal";
import HowToVoteIcon from "@mui/icons-material/HowToVote";
import CalendarMonthIcon from "@mui/icons-material/CalendarToday";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ThumbnailImage from "../../components-new/Thumbnail";
import { toJS } from "mobx";

export const displayVillageNames = (villageList) => {
    if (Array.isArray(villageList)) {
        return villageList.map((x, i) => <span key={i}>{safe_get(x, "label", "")}, </span>);
    } else return "N/A";
};

export const ProjectWorksCardList = observer((props: any) => {
    const { projectid } = useParams();
    const navigate = useNavigate();
    const { projectWorksStore } = useStore();
    const { projectWorksList } = projectWorksStore;

    const projDetailsClickHandler = (fsdid) => {
        navigate(`/project/${projectid}/project_works/${fsdid}`);
    };

    return (
        <>
            {projectWorksList.length > 0 ? (
                <div className="mx-auto grid max-w-lg gap-5 py-4 lg:max-w-none lg:grid-cols-3 xl:grid-cols-4">
                    {projectWorksList.map((project, index) => {
                        const events = safe_get(project, "others.events", []);
                        const coverPhotoPath = safe_get(project, "summary.coverPhotoPath", null);

                        return (
                            <Fade
                                key={project.id}
                                cascade={false}
                                direction="up"
                                delay={index * 10}
                                triggerOnce
                            >
                                <div
                                    className="flex max-h-[600px] cursor-pointer flex-col overflow-hidden rounded-lg shadow-lg"
                                    onClick={() => projDetailsClickHandler(project.id)}
                                    title={safe_get(project, "summary.decription", "")}
                                >
                                    <div className="flex-shrink-0">
                                        <div className="w-full object-cover">
                                            {coverPhotoPath ? (
                                                <ThumbnailImage
                                                    s3Key={coverPhotoPath}
                                                    bucket="urn-assets"
                                                    width={700}
                                                    height={280}
                                                />
                                            ) : (
                                                <img src={"images/default_image.jpeg"} alt={""} />
                                            )}
                                        </div>
                                    </div>
                                    <div className="flex flex-1 flex-col justify-between bg-white p-3">
                                        <div className="flex flex-1 flex-col gap-y-2">
                                            <p className="text-xl font-semibold text-gray-900">
                                                {safe_get(project, "summary.name", "")}
                                            </p>

                                            <div className="flex flex-row gap-x-2">
                                                <LocationOnIcon color="primary" />
                                                <p>{safe_get(project, "summary.location", "")}</p>
                                            </div>

                                            <div className="flex flex-row gap-x-2">
                                                <HowToVoteIcon color="primary" />
                                                <p>{displayVillageNames(project.summary["village"])}</p>
                                            </div>

                                            <div className="flex flex-row items-center gap-x-2">
                                                <CalendarMonthIcon color="primary" />
                                                <p>{safe_get(project, "modified", "")}</p>
                                                {/*<p>{safe_get(project, "summary.workDate", "")}</p>*/}
                                                <RenderRequestStatus
                                                    feature="project_works"
                                                    status={safe_get(project, "summary.status", "")}
                                                />
                                            </div>

                                            {events.length > 0 && (
                                                <div className="flex flex-row gap-x-2">
                                                    <p className="font-bold">Event Date:</p>
                                                    {events.map((event, idx) => (
                                                        <p key={idx} className="font-bold">
                                                            {event.date}
                                                        </p>
                                                    ))}
                                                </div>
                                            )}
                                            <p className="overflow-hidden py-4 text-base text-gray-500">
                                                {safe_get(project, "summary.workDate", "")}
                                            </p>

                                            <p className="overflow-hidden py-4 text-base text-gray-500">
                                                {safe_get(project, "summary.decription", "")}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                        );
                    })}
                </div>
            ) : (
                <DataNotAvailable />
            )}
        </>
    );
});
